import {publishEvent} from "services/events";

export const SET_ONBOARDING_VIDEO_STATE = 'SET_ONBOARDING_VIDEO_STATE';

export function setVideoState({state, prevState, userId}) {
  return dispatch => {
    dispatch({type: SET_ONBOARDING_VIDEO_STATE, payload: state});
    if (state === "playing" && prevState === "unstarted") {
      publishEvent('onboarding video played', { userId })
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/onboardingVideo.js